import Vue from 'vue'
import { Message } from 'element-ui'

Vue.prototype.$message = Message
